<nz-badge [nzDot]="hasUnreadNews$ | async" [nzOffset]="offset">
  <ng-content></ng-content>
</nz-badge>
